// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// начала  this.Code = код ; а потом PFixMessage.call(this, fieldSet);
import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixFieldSet } from '../Fields/FieldsImport';
export class PFixMessage {
    constructor(messageCode, fieldSet) {
        if (fieldSet && fieldSet !== null) {
            this.FieldSet = fieldSet;
        }
        else {
            this.FieldSet = new PFixFieldSet();
        }
        this.Code = messageCode;
        this.FieldSet.SetField(FieldsFactory.FIELD_MSG_TYPE, this.Code);
        this.setSequance();
    }
    getFieldValue(field) {
        return this.FieldSet.GetValue(field);
    }
    setFieldValue(field, value) {
        this.FieldSet.SetField(field, value);
    }
    getGroups(group, GroupCtor) {
        return this.FieldSet.GetGroups(group, GroupCtor);
    }
    addGroup(group) {
        this.FieldSet.AddGroup(group);
    }
    getSequance() {
        return this.FieldSet.GetValue(FieldsFactory.FIELD_SEQUANCE_ID);
    }
    setSequance() {
        this.FieldSet.SetField(FieldsFactory.FIELD_SEQUANCE_ID, PFixMessage.sequance++);
    }
    setRequestId(p) {
        this.setFieldValue(FieldsFactory.FIELD_REQUEST_ID, p);
    }
    getRequestId() {
        return this.FieldSet.GetValue(FieldsFactory.FIELD_REQUEST_ID);
    }
}
PFixMessage.sequance = 0;
